export default __webpack_public_path__ + "assets/logos/d1c3a6d8bdee1ecd01673390b4a43bb7.png";